module.exports = __webpack_public_path__ + "static/media/DSC00181.733d7030.jpg";